module.exports = __webpack_public_path__ + "b029f7558dd780df7a753c781f4e36f0.woff";